import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './StudyEdit.css';

const StudyEdit = () => {
  const { id } = useParams();
  const token = localStorage.getItem('token');

  const [formData, setFormData] = useState({
    study_instance_id: '',
    patient: '',
    uploader: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/patients/studies/${id}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        setFormData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError('Error fetching Study for edit');
        setLoading(false);
      });
  }, [id, token]);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/patients/studies/${id}/edit/`,
        formData,
        { headers: { Authorization: `Token ${token}` } }
      );
      setSuccess(true);
      setError('');
    } catch (err) {
      console.error(err);
      setError('Error updating Study');
      setSuccess(false);
    }
  };

  if (loading) return <p>Loading Study...</p>;
  if (error && !success) return <p className="error-message">{error}</p>;

  return (
    <div className="study-edit-container">
      <h3>Edit Study</h3>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">Study updated successfully!</p>}

      <form onSubmit={handleSubmit} className="study-edit-form">
        <div className="form-group">
          <label>Study Instance ID (Required)</label>
          <input
            type="text"
            name="study_instance_id"
            value={formData.study_instance_id || ''}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="study-edit-btn">
          Update Study
        </button>
      </form>
    </div>
  );
};

export default StudyEdit;
